import { injectIntl } from 'react-intl';
import React, { useContext, useRef, useEffect, useState } from 'react';
import { Input, Row, Col } from 'antd';
import myContext from '@/utils/createContext';
import _ from 'lodash';
import { gtag } from '@/utils'
import FloatLabel from '@/components/H5PC/Form/FloatLabel/index.js';
import allRegex from '@/components/allRegex.js';


function CardName(props) {
  const intl = props.intl;
  const { formatMessage } = intl;
  const { form, initData, showDomain } = useContext(myContext);
  let {cardName, cardFirstName, cardLastName } = initData || '';
  const nameOnCardRef = useRef();
  const [shouldHide, setShouldHide] = useState(false);

  // 校验姓名格式的函数，复用validator逻辑（与第92-117行的validator保持一致）
  const validateNameFormat = (value) => {
    if (_.isEmpty(value)) return false;
    
    //只国际信用卡做该校验  
    if (localStorage.getItem('paymentMethod') === 'icr' && (/\d/.test(value) || value.replace(/(\`|\,|\s)/g, '') === '') && value !== '') { 
      return false;
    }
    
    if (localStorage.getItem('paymentMethod') !== 'lcr' && localStorage.getItem('paymentMethod') !== 'icr') return true;
    
    // 根据当前语言进行校验
    let _lang = localStorage.getItem('locale')
    if (_lang === 'pt-BR' || _lang === 'en-US') {
      const eleArray = value.split(/[\s\n]/);                      
      if(_.uniq(eleArray).length !== eleArray.length){
        return false;
      }                        
    }
    
    return true;
  };

  // 判断是否应该隐藏：需要三个字段有值 AND 格式校验通过
  // 注意：vIndex.jsx的getCardName已在初始化时设置cardName到表单中，直接获取表单值进行校验
  // 为了处理语言切换问题，在隐藏判断时需要检查pt-BR和en-US下的重复单词规则
  // 如果名字在pt-BR或en-US下会校验失败（有重复单词），就不隐藏；否则，如果基本规则通过，就隐藏
  useEffect(() => {
    const hasCardName = !!(cardName || cardFirstName || cardLastName);
    if (hasCardName && form) {
      const formCardName = form.getFieldValue('cardName') || '';
      const isValid = validateNameFormat(formCardName);
      setShouldHide(isValid);
    } else {
      setShouldHide(false);
    }
  }, [cardName, cardFirstName, cardLastName, form, intl.locale]);

  const onBlurCardName = async function(e) {
    gtag(`${showDomain}支付页面`, [new Date() + '输入持卡人姓名']);
    gtag(`${showDomain}支付页面`, ['输入持卡人姓名']);
    showDomain ? gtag(`定制支付页面`, ['输入持卡人姓名']):'';
  };

  return (
    <Row gutter={20} style={{ marginBottom: '-10px', padding: '0 15px', display: shouldHide ? 'none' : 'block' }}>
        <Col span={24}>
          <FloatLabel
            extra={localStorage.getItem('paymentMethod') === 'lcr'?formatMessage({id: 'ga-checkout.new-full-name-extraTip' }):''}
            form={form}
            name="cardName"
            cref={nameOnCardRef}
            // label="Name on Card"
            label={formatMessage({
              id: 'ga-checkout.name-on-card',
            })}
            rules={[
              {
                required: true,
                message: formatMessage({
                  id: 'ga-checkout.please-enter-name-on-card',
                }),
              },
              ({ getFieldValue }) => ({
                validator: async (rule, value) => { 
                  //只国际信用卡做该校验  
                  if (localStorage.getItem('paymentMethod') === 'icr' && (/\d/.test(value) || value.replace(/(\`|\,|\s)/g, '') === '')&& value !== '') { 
                    console.log(value.trim());
                    return Promise.reject(
                      formatMessage({
                        id: 'ga-checkout.name-all-number',
                      }),
                    );    
                  };
                  if (localStorage.getItem('paymentMethod') !== 'lcr' && localStorage.getItem('paymentMethod') !== 'icr') return;
                  if (_.isEmpty(value)) return;
                  let _lang = localStorage.getItem('locale')
                  if (_lang === 'pt-BR' || _lang === 'en-US') {
                    const eleArray = value.split(/[\s\n]/);                      
                    if(_.uniq(eleArray).length !== eleArray.length){
                      return Promise.reject(
                        formatMessage({
                          id: 'ga-checkout.name-repeat-tip',
                        }),
                      );
                    }                        
                  }                   
                },
              }),

            ]}
          >
            <Input             
              size="large"
              maxLength={128}
			  onBlur={e => onBlurCardName(e)}
			  style={{ paddingRight: '40px' }}
            />
          </FloatLabel>
        </Col>
      </Row>
  );
}

export default injectIntl(CardName);
